<template>
  <ProductProvider v-if="shopifyHandle" v-slot="{ product }" :handle="shopifyHandle">
    <ProductReviews v-if="product" :product="product" />
  </ProductProvider>
</template>

<script setup>
import ProductProvider from '@/components/common/ProductProvider';
import ProductReviews from './ProductReviews.vue';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  shopifyHandle: {
    type: String,
    default: null,
  },
});
</script>
